var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgECatalouge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11010_1758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.65625 0V31.3438H15.4395V0H2.65625ZM9.04898 26.9676C7.94 26.9676 7.03906 26.0711 7.03906 24.9622C7.03906 23.8532 7.93993 22.9545 9.04672 22.9545C10.1579 22.9545 11.0566 23.8532 11.0566 24.9622C11.0566 26.0711 10.158 26.9676 9.04898 26.9676Z",
    fill: "#02A9F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.65625 27.6139L6.38609 31.3437H9.77055L15.4395 25.6726V7.5957L2.65625 20.38V27.6139ZM8.0839 21.9893C8.89186 21.9893 9.58023 22.4663 9.89898 23.1492C10.583 23.4702 11.0567 24.1586 11.0567 24.9621C11.0567 26.0711 10.158 26.9675 9.04905 26.9675C8.24334 26.9675 7.55271 26.4917 7.23171 25.8076C6.55217 25.4867 6.07624 24.7994 6.07624 23.997C6.07617 22.8891 6.97711 21.9893 8.0839 21.9893Z",
    fill: "#006AB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1639 2.79785L0.00195312 24.9621L9.03984 34L31.2019 11.8357L22.1639 2.79785ZM9.04868 26.9675C7.93969 26.9675 7.03876 26.0711 7.03876 24.9621C7.03876 23.8531 7.93963 22.9545 9.04642 22.9545C10.1576 22.9545 11.0563 23.8531 11.0563 24.9621C11.0563 26.0711 10.1577 26.9675 9.04868 26.9675Z",
    fill: "#FF6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.65625 22.3081V27.6162L5.42765 30.3875H12.6526L25.4337 17.6055H7.35788L2.65625 22.3081ZM11.0566 23.997C11.0566 24.1641 11.0301 24.3247 10.9902 24.4795C11.0301 24.6345 11.0566 24.7939 11.0566 24.9622C11.0566 26.0711 10.158 26.9676 9.04898 26.9676C7.94 26.9676 7.03906 26.0711 7.03906 24.9622C7.03906 24.7939 7.06563 24.6345 7.10547 24.4795C7.06563 24.3247 7.03906 24.1641 7.03906 23.997C7.03906 22.8891 7.93993 21.9893 9.04672 21.9893C10.158 21.9893 11.0566 22.8891 11.0566 23.997Z",
    fill: "#E63431"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.65625 18.5693V31.3525H34V18.5693H2.65625ZM9.04898 26.9675C7.94 26.9675 7.03906 26.0711 7.03906 24.9621C7.03906 23.8531 7.93993 22.9545 9.04672 22.9545C10.1579 22.9545 11.0566 23.8531 11.0566 24.9621C11.0566 26.0711 10.158 26.9675 9.04898 26.9675Z",
    fill: "#F4D177"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11010_1758"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgECatalouge);
export default __webpack_public_path__ + "static/media/E-Catalouge.1c9b26e83837901615fc10cda3afa056.svg";
export { ForwardRef as ReactComponent };